export const TIDS = {
  // Landing
  navLogo: "nav-logo",
  navBecomePartner: "nav-become-partner",
  navPartnerLogin: "nav-partner-login",
  navAdminLogin: "nav-admin-login",
  heroCtaPrimary: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",
  faqItem: "faq-item",
  footerCompliance: "footer-compliance",
  referralBanner: "referral-banner",

  // Signup
  signupForm: "partner-signup-form",
  signupFullName: "signup-full-name",
  signupEmail: "signup-email",
  signupMobile: "signup-mobile",
  signupCompany: "signup-company",
  signupHowKnow: "signup-how-know",
  signupPaymentMethod: "signup-payment-method",
  signupAgree: "signup-agree",
  signupSubmit: "signup-submit",
  signupReferredBy: "signup-referred-by",

  // Partner login
  partnerLoginForm: "partner-login-form",
  partnerLoginMobile: "partner-login-mobile",
  partnerLoginSendOtp: "partner-login-send-otp",
  partnerLoginCode: "partner-login-code",
  partnerLoginVerify: "partner-login-verify",

  // Admin login
  adminLoginForm: "admin-login-form",
  adminLoginEmail: "admin-login-email",
  adminLoginPassword: "admin-login-password",
  adminLoginSubmit: "admin-login-submit",

  // Partner dashboard
  partnerDashboard: "partner-dashboard",
  partnerStatsPaid: "partner-stats-paid",
  partnerStatsUnpaid: "partner-stats-unpaid",
  partnerStatsTotal: "partner-stats-total",
  partnerStatsFunded: "partner-stats-funded",
  partnerLogout: "partner-logout",
  partnerNavSubmit: "partner-nav-submit",
  partnerReferralLinkCard: "partner-referral-link-card",
  partnerReferralCopyBtn: "partner-referral-copy-btn",
  partnerRecruitsCount: "partner-recruits-count",

  // Submit referral
  submitReferralForm: "submit-referral-form",
  submitOwnerName: "submit-owner-name",
  submitBusinessName: "submit-business-name",
  submitOwnerPhone: "submit-owner-phone",
  submitOwnerEmail: "submit-owner-email",
  submitMonthlyRevenue: "submit-monthly-revenue",
  submitFundingNeeded: "submit-funding-needed",
  submitTimeInBusiness: "submit-time-in-business",
  submitNotes: "submit-notes",
  submitFile: "submit-file",
  submitButton: "submit-referral-button",

  // Referrals list
  referralRow: "referral-row",
  referralStatusBadge: "referral-status-badge",
  referralOpen: "referral-open",

  // Detail
  referralDetail: "referral-detail",
  detailStatusSelect: "detail-status-select",
  detailFundingAmount: "detail-funding-amount",
  detailCommissionAmount: "detail-commission-amount",
  detailCommissionPaid: "detail-commission-paid",
  detailInternalNotes: "detail-internal-notes",
  detailPartnerNotes: "detail-partner-notes",
  detailSave: "detail-save",
  detailUploadFile: "detail-upload-file",
  detailUploadVisibility: "detail-upload-visibility",
  detailUploadButton: "detail-upload-button",

  // Admin
  adminDashboard: "admin-dashboard",
  adminLogout: "admin-logout",
  adminFilterStatus: "admin-filter-status",
  adminFilterPartner: "admin-filter-partner",
  adminFilterSearch: "admin-filter-search",
  adminTabReferrals: "admin-tab-referrals",
  adminTabPartners: "admin-tab-partners",
  adminTabEmployees: "admin-tab-employees",
  adminTabActivity: "admin-tab-activity",
  adminInviteCreate: "admin-invite-create",
  adminInviteCodeRow: "admin-invite-code-row",
  adminInviteCopy: "admin-invite-copy",
  adminInviteRevoke: "admin-invite-revoke",
  adminAddEmployee: "admin-add-employee",
  adminAddEmployeeSubmit: "admin-add-employee-submit",
  adminEmployeeRow: "admin-employee-row",
  adminEmployeeDelete: "admin-employee-delete",
  adminReferralDelete: "admin-referral-delete",
  detailDelete: "detail-delete",

  // Employee
  employeeSignupForm: "employee-signup-form",
  employeeSignupName: "employee-signup-name",
  employeeSignupEmail: "employee-signup-email",
  employeeSignupPassword: "employee-signup-password",
  employeeSignupCode: "employee-signup-code",
  employeeSignupSubmit: "employee-signup-submit",
  employeeLoginForm: "employee-login-form",
  employeeLoginEmail: "employee-login-email",
  employeeLoginPassword: "employee-login-password",
  employeeLoginSubmit: "employee-login-submit",
  employeeDashboard: "employee-dashboard",
  employeeLogout: "employee-logout",
  employeeRecruitLinkCard: "employee-recruit-link-card",
  employeeRecruitLinkCopy: "employee-recruit-link-copy",
  employeeAddPartner: "employee-add-partner",
  employeeAddPartnerSubmit: "employee-add-partner-submit",

  // Client
  navClientLogin: "nav-client-login",
  clientLoginForm: "client-login-form",
  clientLoginMobile: "client-login-mobile",
  clientLoginSendOtp: "client-login-send-otp",
  clientLoginCode: "client-login-code",
  clientLoginVerify: "client-login-verify",
  clientDashboard: "client-dashboard",
  clientLogout: "client-logout",
  clientApplicationCard: "client-application-card",
  clientBecomePartnerBtn: "client-become-partner-btn",
  becomePartnerReferralSource: "become-partner-referral-source",
  becomePartnerConfirm: "become-partner-confirm",
  applyTrackLink: "apply-track-link",
  applyDropZone: "apply-drop-zone",
  applyFileInput: "apply-file-input",
  applyFileList: "apply-file-list",
  partnerReferralsCard: "partner-referrals-card",

  // Drill-down (admin + employee)
  adminEmployeeBack: "admin-employee-back",
  adminEmployeeDetail: "admin-employee-detail",
  adminEmployeeRowDrill: "admin-employee-row-drill",
  adminEmpPartnerRow: "admin-emp-partner-row",
  partnerDetailBack: "partner-detail-back",
  partnerDetailView: "partner-detail-view",
  partnerDetailClientRow: "partner-detail-client-row",
  empPartnerRowDrill: "emp-partner-row-drill",

  // Edit employee dialog
  adminEmployeeEdit: "admin-employee-edit",
  editEmpName: "edit-emp-name",
  editEmpEmail: "edit-emp-email",
  editEmpMobile: "edit-emp-mobile",
  editEmpPassword: "edit-emp-password",
  editEmpSubmit: "edit-emp-submit",

  // Edit partner dialog
  adminPartnerEdit: "admin-partner-edit",
  editPartnerName: "edit-partner-name",
  editPartnerEmail: "edit-partner-email",
  editPartnerMobile: "edit-partner-mobile",
  editPartnerCompany: "edit-partner-company",
  editPartnerPayment: "edit-partner-payment",
  editPartnerEmployee: "edit-partner-employee",
  editPartnerSubmit: "edit-partner-submit",

  // Team (unified) login
  teamLoginForm: "team-login-form",
  teamLoginMobile: "team-login-mobile",
  teamLoginSendOtp: "team-login-send-otp",
  teamLoginCode: "team-login-code",
  teamLoginVerify: "team-login-verify",
  navTeamLogin: "nav-team-login",
};
